function ArrowRightSimpleIcon() {
  return (
    <svg viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
      <path d='M5 12h14M12 5l7 7-7 7' />
    </svg>
  )
}

export default ArrowRightSimpleIcon
